<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="RECEBÍVEIS ANALÍTICO" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF"
            :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="6" :totalPDF="total - 1" 
            :titleReport="titleReport" :totalHide="true" forma="l">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout-item md-size-10 md-xsmall-size-100">
                            <md-field>
                                <label for="pages">Listar</label>
                                <md-select v-model="pagination.perPage" name="pages">
                                    <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                        {{ item }}
                                    </md-option>
                                </md-select>
                            </md-field>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataInicial" md-immediately v-mask="'##/##/####'">
                                    <label>Data Inicial</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-20 md-xsmall-size-100">
                                <md-datepicker v-model="buscar.dataFinal" md-immediately v-mask="'##/##/####'">
                                    <label>Data Final</label>
                                </md-datepicker>
                            </div>
                            <div class="md-layout-item md-size-40 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Cliente, Empresa ou Fornecedor" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-block md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell md-label="VENDA" style="width: 5%">{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CLIENTE" style="width: 25%">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="EMPRESA" style="width: 18%">{{ item.empresa }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="FORNECEDOR" style="width: 18%">{{ item.fornecedor }}</md-table-cell>
                        <md-table-cell md-label="VENCIMENTO" style="width: 10%">{{ item.data_vencimento }}</md-table-cell>
                        <md-table-cell v-if="item.id" md-label="PARCELA" style="width: 5%">
                            {{ item.parcela }}
                        </md-table-cell>
                        <md-table-cell v-if="item.parcela == 'SUB-TOTAL'|| item.parcela == 'TOTAL'" md-label="PARCELA" style="width: 5%">
                            <strong>{{ item.parcela }}</strong>
                        </md-table-cell>
                        <md-table-cell v-if="item.id" md-label="VALOR" style="width: 10%">{{ item.total }}</md-table-cell>
                        <md-table-cell v-if="item.parcela == 'SUB-TOTAL'|| item.parcela == 'TOTAL'" md-label="VALOR" style="width: 10%">
                            <strong>{{ item.total }}</strong>
                        </md-table-cell>
                        <md-table-cell v-if="item.id" md-label="DESC." style="width: 5%">{{ item.desconto }}</md-table-cell>
                        <md-table-cell v-if="item.parcela == 'SUB-TOTAL'" md-label="DESC." style="width: 5%"><strong>{{ item.desconto }}</strong></md-table-cell>
                        <md-table-cell v-if="item.parcela == 'TOTAL'" md-label="DESC." style="width: 5%"><strong>{{ item.desconto }}</strong></md-table-cell>
                        <md-table-cell v-if="item.id" md-label="LÍQUIDO" style="width: 5%">{{ item.liquido }}</md-table-cell>
                        <md-table-cell v-if="item.parcela == 'SUB-TOTAL'" md-label="LÍQUIDO" style="width: 5%"><strong>{{ item.liquido }}</strong></md-table-cell>
                        <md-table-cell v-if="item.parcela == 'TOTAL'" md-label="LÍQUIDO" style="width: 5%"><strong>{{ item.liquido }}</strong></md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to - 1" :total="total - 1">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import Pagamento from '@/config/mixins/print/pagamento'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';
import getDateFormat from '@/config/mixins/getDateFormat';
import Swal from "sweetalert2";

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            detalhes: {},
            totalGeral: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'pagamentos/',
            rotaExcluir: 'pagamentos/excluir/',
            titleReport: "",
            columnsPDF: [18, 60, 50, 40, 25, 22, 23, 20, 22], //max 270-280
            headRowsPDF: ['VENDA', 'CLIENTE', 'EMPRESA', 'FORNECEDOR', 'VENCIMENTO', 'PARCELA', 'VALOR', 'DESC', 'LÍQUIDO'],
            bodyRowsPDF: ['id', 'nome', 'empresa', 'fornecedor', 'data_vencimento', 'parcela', 'total', 'desconto', 'liquido'],
            fildsTXT: ['id', 'nome', 'empresa', 'fornecedor', 'data_vencimento', 'parcela', 'total_txt', 'desconto_txt', 'liquido_txt'],
            columnsExcel: [

                {
                    label: "VENDA",
                    field: "id",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CLIENTE",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "EMPRESA",
                    field: "empresa",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "FORNECEDOR",
                    field: "fornecedor",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "VENCIMENTO",
                    field: "data_vencimento"
                },
                {
                    label: "PARCELA",
                    field: "parcela"
                },
                {
                    label: "VALOR",
                    field: "total_bd"
                },
                {
                    label: "DESC",
                    field: "desconto_bd"
                },
                {
                    label: "LÍQUIDO",
                    field: "liquido_bd"
                },
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, Pagamento, getDateFormat],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            this.titleReport = 'Relatório de Recebíveis Analítico - Período ' 
            + this.getDataInicial(this.buscar.dataInicial) + ' a ' + this.getDataFinal(this.buscar.dataFinal)
            this.buscar.situacao_id = this.dados.situacao_id
            let loader = this.openLoader('dots');
            pagi = pagi || this.$urlAPI + 'pagamentos/repasse-fornecedor'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.totalGeral = response.data.total
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.cpf_placa, item.data_pagamento, item.valor]).includes(this.toLower(term)))
            }
            return items
        }
    },
};
</script>
<style>
.md-layout-item {
    margin-top: 5px;
}
</style>
